export default __webpack_public_path__ + "static/anyonewithlink1-9cd338af9a8d8df20e2336fe6be11fd8.png";